import { createContext, useContext } from 'react'

interface ActiveVideoVisitContextValue {
  activeVideoVisitId: number | null
  setActiveVideoVisitId: (id: number | null) => void
  clearActiveVideoVisit: () => void
}

export const ActiveVideoVisitContext = createContext<ActiveVideoVisitContextValue>({
  activeVideoVisitId: null,
  setActiveVideoVisitId: () => {},
  clearActiveVideoVisit: () => {},
})

/** Reads the value `app/`'s ActiveVideoVisitProvider put on context. */
export const useActiveVideoVisit = () => useContext(ActiveVideoVisitContext)
